import { createAsyncAction } from "../../helpers/actions"
import { logout } from "../api/logout"
import { LOGOUT_USER } from "../constants/ActionTypes"

export const logoutUser = createAsyncAction(LOGOUT_USER, logout)
